/**
 * @file 领取质押奖励弹窗
 */
import { useEffect } from 'react';
import { CloudClaimModal } from './cloud';
import { ThirdClaimModal } from './third';
import { useWallet } from '@/hooks/wallet';
import { ClaimType } from '@/types/claim';
import { PoolInfo } from '@/types/pool';
import { scTrack } from '@web3/base-tracking';
import { Event } from '@/config/track-config';

import styles from './index.module.scss';

interface Props {
  poolInfo: PoolInfo;
  claimType: ClaimType;
  onCloseClaimModal: () => void;
}

export const ClaimModal = (props: Props) => {
  const { claimType, poolInfo, onCloseClaimModal } = props;
  const { isThird } = useWallet();

  useEffect(() => {
    scTrack(Event.Web3PageView, {
      page_name:
        claimType === ClaimType.Claim
          ? 'StakingWeb_bbSOLrewards'
          : 'StakingWeb_bbSOLPagewithdrawal',
    });
  }, [claimType]);

  return (
    <div className={styles.container}>
      {isThird && (
        <ThirdClaimModal
          poolInfo={poolInfo}
          claimType={claimType}
          onCloseClaimModal={onCloseClaimModal}
        />
      )}
      {!isThird && (
        <CloudClaimModal
          poolInfo={poolInfo}
          claimType={claimType}
          onCloseClaimModal={onCloseClaimModal}
        />
      )}
    </div>
  );
};
